import { serverHttp as Request } from "./http";

class AiService {
  // 管理员
  // 获取上传模型配置
  getModelSetting() {
    return Request.get("sharkfoto/ai_model_setting");
  }
  // 用户
  // 获取用户历史记录
  getUserHistory(
    userId,
    is_all,
    tool_name,
    get_type,
    target_email,
    admin_query_type,
    admin_query_value
  ) {
    const params = { user_id: userId };
    if (is_all !== undefined && is_all !== null && is_all !== "") {
      params.is_all = is_all;
    }
    if (tool_name !== undefined && tool_name !== null) {
      params.tool_name = tool_name;
    }
    if (get_type !== undefined && get_type !== null && get_type !== "") {
      params.get_type = get_type;
    }
    if (target_email !== undefined && target_email !== null && target_email !== "") {
      params.target_email = target_email;
    }
    if (
      admin_query_type !== undefined &&
      admin_query_type !== null &&
      admin_query_type !== ""
    ) {
      params.admin_query_type = admin_query_type;
    }
    if (
      admin_query_value !== undefined &&
      admin_query_value !== null &&
      admin_query_value !== ""
    ) {
      params.admin_query_value = admin_query_value;
    }
    return Request.get("sharkfoto/user_predictions", {
      params,
    });
  }
  // 归档用户历史记录
  setUserHistory(id, set_type) {
    return Request.post("sharkfoto/user_predictions", { id, set_type });
  }
  // 获取任务状态(支持单个和批量)
  getTaskStatus(ids, userId) {
    return Request.get("sharkfoto/task_status", {
      params: {
        ids: Array.isArray(ids) ? ids.join(",") : ids,
        user_id: userId,
      },
      timeout: 180000, // 3分钟超时
    });
  }
}

export default new AiService();
